<template>
  <div class="m-4 md:mx-8 md:mt-16">
    <div class="flex flex-col md:flex-row md:items-center justify-between mb-4 space-y-2 md:space-y-0">
      <span class="font-semibold text-primario text-lg tracking-wide">{{ $t("lang.msg.designer") }}</span>
      <div class="flex space-x-2 w-full md:max-w-lg">
        <ButtonAction @action="toggleActive" color="gray" large>
          {{ showActive ? $t('lang.msg.viewDisactives') : $t('lang.msg.viewActives') }}
        </ButtonAction>
        <ButtonAction @action="openCreateModal" color="gray" large>
          {{ $t('lang.msg.add') }}
        </ButtonAction>
      </div>
    </div>
    <datatable
      :data="data"
      :headers="headers"
      @on-row-click="openEditModal"
    />
    <TheModal
      :open="isModalOpen"
      @close="isModalOpen = false"
      :title="newItem.idDesigner == undefined ? $t('lang.msg.createRecord') : $t('lang.msg.updateRecord')"
    >
      <template #body>
        <form class="pt-3 space-y-4">
          <InputWrapper :label="$t('lang.fields.name')" content="input" block>
            <InputText v-model="newItem.designerName" :name="$t('lang.fields.name')" />
          </InputWrapper>
          <InputWrapper :label="$t('lang.fields.lastname')" content="input" block>
            <InputText v-model="newItem.designerLastName" :name="$t('lang.fields.lastname')" />
          </InputWrapper>
          <InputWrapper :label="$t('lang.fields.phone')" content="input" block>
            <InputText v-model="newItem.designerPhone" :name="$t('lang.fields.phone')" />
          </InputWrapper>
          <InputWrapper :label="$t('lang.fields.email')" content="input" block>
            <InputText v-model="newItem.designerEmail" :name="$t('lang.fields.email')" />
          </InputWrapper>
          <InputWrapper :label="$t('lang.fields.address')" content="input" block>
            <textarea
              v-model="newItem.designerAdress"
              :placeholder="$t('lang.fields.address')"
              class="form-textarea w-full pr-6"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.fields.anotations')" content="input" block>
            <textarea
              v-model="newItem.anotacion"
              :placeholder="$t('lang.fields.anotations')"
              class="form-textarea w-full pr-6"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.client')" content="input" block>
            <Select
              id="idClient"
              :data="clients"
              track-by="clientName"
              :placeholder="$t('lang.msg.client')"
              v-model.number="newItem.idClient"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.department')" content="input" block>
            <Select
              id="idSection"
              :data="departments"
              track-by="sectionName"
              :placeholder="$t('lang.msg.department')"
              v-model.number="newItem.idSection"
            />
          </InputWrapper>
          <AdminToggleButton v-model="newItem.active" />
        </form>
      </template>
      <template #action>
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 hover:bg-green-700 text-base font-medium text-white shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150"
            @click="addOrEditItem(`api/Designers/Add`, `api/Designers/Update`, true)"
          >{{ newItem.idDesigner == undefined ? $t('lang.msg.add') : $t('lang.msg.update') }}</button>
        </span>
      </template>
    </TheModal>
  </div>
</template>

<script>
import AdminMixin from "@/components/mixins/AdminMixin";
import TheModal from "@/components/shared/TheModal";
import DataTable from "@/components/shared/DataTable";

export default {
  name: "Designers",
  mixins: [AdminMixin],
  components: {
    datatable: DataTable,
    TheModal
  },
  data() {
    return {
      departments: [],
      data: [],
      headers: {
        idDesigner: "#",
        designerName: this.$t("lang.fields.name"),
        designerLastName: this.$t("lang.fields.lastname"),
        designerPhone: this.$t("lang.fields.phone"),
        designerEmail: this.$t("lang.fields.email"),
        designerAdress: this.$t("lang.fields.address"),
        clientName: this.$t("lang.msg.client"),
        active: {
          name: this.$t("lang.msg.active"),
          type: Boolean
        }
      }
    };
  },
  created() {
    this.fetchData(`api/Designers/GetDesigner`);
    this.fetchClients();
    this.fetchDepartments();
  },
  methods: {
    fetchDepartments() {
      this.$axios.get(`api/Sections/getSection`).then( response => {
        this.departments = response.data
      })
    }
  }
};
</script>
